export default __webpack_public_path__ + "static/media/beauty1.92002531.jpg";